import { useTranslation, Trans } from 'react-i18next';
import LegalPageLayout from '@/components/legal/LegalPageLayout';

export default function TermsOfService() {
  const { t } = useTranslation();

  return (
    <LegalPageLayout
      title={t('terms.title')}
      lastUpdated={t('terms.lastUpdated')}
    >
      <section>
        <p className="lead text-lg text-gray-700 mb-8">
          {t('terms.intro')}
        </p>
      </section>

      <section className="mb-8">
        <h2>{t('terms.sections.acceptance.title')}</h2>
        <p>{t('terms.sections.acceptance.content')}</p>
      </section>

      <section className="mb-8">
        <h2>{t('terms.sections.description.title')}</h2>
        <p>{t('terms.sections.description.content')}</p>
        <ul>
          <li>{t('terms.sections.description.features.profile')}</li>
          <li>{t('terms.sections.description.features.qrCode')}</li>
          <li>{t('terms.sections.description.features.vcard')}</li>
          <li>{t('terms.sections.description.features.protection')}</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2>{t('terms.sections.accounts.title')}</h2>
        <p>{t('terms.sections.accounts.content')}</p>
        <ul>
          <li>{t('terms.sections.accounts.responsibilities.accurate')}</li>
          <li>{t('terms.sections.accounts.responsibilities.secure')}</li>
          <li>{t('terms.sections.accounts.responsibilities.activity')}</li>
          <li>{t('terms.sections.accounts.responsibilities.notify')}</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2>{t('terms.sections.acceptable.title')}</h2>
        <p>{t('terms.sections.acceptable.intro')}</p>
        <ul>
          <li>{t('terms.sections.acceptable.prohibited.illegal')}</li>
          <li>{t('terms.sections.acceptable.prohibited.impersonate')}</li>
          <li>{t('terms.sections.acceptable.prohibited.spam')}</li>
          <li>{t('terms.sections.acceptable.prohibited.interfere')}</li>
          <li>{t('terms.sections.acceptable.prohibited.scrape')}</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2>{t('terms.sections.content.title')}</h2>
        <p>{t('terms.sections.content.ownership')}</p>
        <p className="mt-4">{t('terms.sections.content.license')}</p>
      </section>

      <section className="mb-8">
        <h2>{t('terms.sections.ip.title')}</h2>
        <p>{t('terms.sections.ip.content')}</p>
      </section>

      <section className="mb-8">
        <h2>{t('terms.sections.disclaimer.title')}</h2>
        <p>{t('terms.sections.disclaimer.content')}</p>
      </section>

      <section className="mb-8">
        <h2>{t('terms.sections.liability.title')}</h2>
        <p>{t('terms.sections.liability.content')}</p>
      </section>

      <section className="mb-8">
        <h2>{t('terms.sections.termination.title')}</h2>
        <p>{t('terms.sections.termination.content')}</p>
      </section>

      <section className="mb-8">
        <h2>{t('terms.sections.changes.title')}</h2>
        <p>{t('terms.sections.changes.content')}</p>
      </section>

      <section className="mb-8">
        <h2>{t('terms.sections.law.title')}</h2>
        <p>{t('terms.sections.law.content')}</p>
      </section>

      <section>
        <h2>{t('terms.sections.contact.title')}</h2>
        <p>
          <Trans i18nKey="terms.sections.contact.content">
            For questions about these Terms, contact us at <a href="mailto:contact@mypink.contact">contact@mypink.contact</a>
          </Trans>
        </p>
      </section>
    </LegalPageLayout>
  );
}
